import addressbook from "./addressbook";

export default {
  en: {
    messages: {
      attemptreenable:"Attempt to re-enable",
      loading:"Loading...",
      yourdetails:"Your details",
      email:"Email",
      changepassword:"Change password",
      deleteaccount:"Delete account",
      key:"Key",
      copy:"Copy",
      copying:"Copied!",
      change:"Change",
      paymentmethod:"Payment method",
      nopaymentmethod:"No payment method",
      accountdetails: "Account details",
      updatecustomerinfo: "Address, tax & invoices",
      recentusage:"Recent Usage",
      openingPaymentPage: "Opening the payment processing page...",
      notsignedin:"You aren't signed into an account. Please {0} to access account information.",
      signin:"sign in",
      confirmDeleteTitle: "Confirm account deletion",
      confirmDeleteDesc: "This will immediate disable your account and schedule your account for deletion.",
      confirmReenableTitle: "Confirm re-enabling attempt",
      confirmReenableDesc: "We will attempt to reenable your account. Multiple account disable events will require a longer waiting time and may cause a permanent ban.",
      confirmApiKeyChangeTitle: "Confirm changing the API key",
      confirmApiKeyChangeDesc: "Your API key will be changed immediately. Queries using the old key will fail. Please confirm that you want to change your key.",
      createsecret:"Create a new secret key",
      confirmSecretChangeTitle: "Confirm creating a new secret key",
      confirmSecretChangeDesc: "This will create a new secret key for your account. The old secret key will be invalidated and cannot be used anymore. Please confirm that you want to create a new secret key.",
      secretkeymodaltitle: "New secret",
      yournewsecretkey: "Your new secret",
      copysecretkeywarning: "Please copy your new secret key now. You won't be able to see it again.",
      addressbook: "Address Book",
    }
  },
  de: {
    messages: {
      attemptreenable: "Versuch, erneut zu aktivieren",
      loading: "Lädt...",
      yourdetails: "Ihre Details",
      email: "E-Mail",
      changepassword: "Passwort ändern",
      deleteaccount: "Konto löschen",
      key: "Schlüssel",
      copy: "Kopieren",
      copying:"Kopiert!",
      change: "Ändern",
      paymentmethod: "Zahlungsmethode",
      nopaymentmethod: "Keine Zahlungsmethode",
      accountdetails: "Kontodetails",
      updatecustomerinfo: "Adresse, Steuer & Rechnungen",
      recentusage: "Letzte Nutzung",
      openingPaymentPage: "Öffne die Zahlungsabwicklungsseite...",
      notsignedin: "Sie sind nicht an einem Konto angemeldet. Bitte {0}, um auf Kontoinformationen zuzugreifen.",
      signin: "Anmelden",
      confirmDeleteTitle: "Löschen des Kontos bestätigen",
      confirmDeleteDesc: "Das Konto wird hiermit sofort deaktiviert und zur Löschung vorgemerkt.",
      confirmReenableTitle: "Wiederherstellungsversuch bestätigen",
      confirmReenableDesc: "Wir werden versuchen, das Konto wiederherzustellen. Mehrere Deaktivierungen des Kontos führen zu längeren Wartezeiten und können zu einer dauerhaften Sperrung führen.",
      confirmApiKeyChangeTitle: "Änderung des API-Schlüssels bestätigen",
      confirmApiKeyChangeDesc: "Der API-Schlüssel wird sofort geändert. Anfragen mit dem alten Schlüssel werden fehlschlagen. Änderung des API-Schlüssels bestätigen.",
      createsecret: "Neuen geheimen Schlüssel erstellen",
      confirmSecretChangeTitle: "Erstellen eines neuen geheimen Schlüssels bestätigen",
      confirmSecretChangeDesc: "Dies erstellt einen neuen geheimen Schlüssel für Ihr Konto. Der alte Schlüssel wird ungültig und kann nicht mehr verwendet werden. Bitte bestätigen Sie, dass Sie einen neuen geheimen Schlüssel erstellen möchten.",
      secretkeymodaltitle: "Neuer geheimer Schlüssel",
      yournewsecretkey: "Ihr neuer geheimer Schlüssel",
      copysecretkeywarning: "Bitte kopieren Sie jetzt Ihren neuen geheimen Schlüssel. Sie werden ihn später nicht mehr einsehen können.",

    }
  },
};
